define('Responsive/helpers/RootViewHelper',['require','exports','module','../util/renderComplete','../util/extend','../util/dom'],function(require,exports,module){
    var ReRenderComplete = require( '../util/renderComplete' ),
        extend = require('../util/extend'),
        ReDom = require( '../util/dom' );

    var undef,
        sizeHandlerEvent= 'resize',
        rxAutoheight=/\s*autoHeight\s*/g;

    
    function RootViewHelper(parent,config){
        var that=this;
        this.parent=parent;
        this.resizing=false;
        this.debounceTime = 0;
        if(!parent.rootView) {
            parent.rootViewHelper=this;
            extend(parent,config);
            parent.setClassName("responsive-root-view");
            parent.setClassName("responsive-app");  
            that.setMinHeight();
            parent.showOverlay();
            parent.setClassName(parent.docRoot,"responsive-booted");
            parent.viewWillAppear();
            parent.viewDidAppear();
            ReRenderComplete(function(){
                that.setMinHeight();
                parent.hideOverlay();
                parent.checkResized();
            });
        }       
    }

    RootViewHelper.prototype = {
        addListener : function(){
            var that=this;
             if(!this.parent.parentViewController){
                this.onresize=function(e){
                    clearTimeout(that.debounced);
                    that.debounced=setTimeout(function(){
                        that.resizeListener(e);
                    },that.debounceTime);
                }
                this.parent.window.addEventListener(sizeHandlerEvent,this.onresize,true);
            }
        },

        removeListener : function(){
            if(this.onresize){
                this.parent.window.removeEventListener(sizeHandlerEvent,this.onresize,true);                    
            }
        },

        resizeListener : function(e){
            var that=this;
            if(this.resizing || !that.parent.isViewLoaded()){
                return;
            }
            this.resizing=true;
            this.parent.checkResized();
            this.parent.checkHeight();
            ReRenderComplete(function(){
                that.resizing=false;
                that.setMinHeight();
            });
            return false;
        },

        getViewOffset : function(){
            var parent = this.parent,
                containerBounds=0,
                containerOffset=0,
                offsetBounds,
                containerBottom=0,
                view=parent.rootView || this.parent.view,
                baseHeight=this.parent.window.innerHeight,
                rect;
            if(view){
                // nonBounds=$(view).offset();
                rect=view.getBoundingClientRect();
                offsetBounds=rect.top;
                containerBottom=document.body.offsetHeight;
                offsetBottom=view.nextElementSibling ? rect.bottom : view.offsetParent ? view.offsetParent.getBoundingClientRect().bottom : containerBottom;
                containerOffset=(offsetBounds-containerBounds)+(containerBottom >= offsetBottom ? (containerBottom-offsetBottom) : 0);
            }

            return baseHeight - containerOffset;

        },


        adjustAvailableHeight : function(){
            var newHeight= (this.parent.fixedHeight <= 0) ? this.getViewOffset() : this.parent.fixedHeight;

            if(newHeight!=='auto'){
                if(newHeight < (this.parent.autoHeight-(this.parent.autoHeightInclusive===true ? this.parent.containerOffset : 0))){
                    newHeight="auto";
                    this.parent.setClassName(this.parent.docRoot,'autoHeight');
                }else{
                    this.parent.docRoot.className=this.parent.docRoot.className.replace(rxAutoheight,'');
                }
                if(this.parent.hideAppBar && window.pageYOffset <= 0){
                    this.parent.window.scrollTo(0,1);
                }

            }

            return newHeight;           
        },
        setMinHeight:function(){
            //return this;
            var height = this.adjustAvailableHeight();

            var styleGen=ReDom.createStyleNode({
                    css : ".responsive-root-view {" +
                            "min-height : " + height + "px;" +
                        "}"
                },this.styleGen);
            if(!this.styleGen){
                this.styleGen=styleGen;
                this.parent.docRoot.getElementsByTagName('head')[0].appendChild(styleGen);
            }
            // this.getView().style.minHeight=height + 'px';
            return this;
        },
    };

    return RootViewHelper;
});
